import { render, staticRenderFns } from "./FrontpageCards.vue?vue&type=template&id=26176d10&"
import script from "./FrontpageCards.vue?vue&type=script&lang=js&"
export * from "./FrontpageCards.vue?vue&type=script&lang=js&"
import style0 from "./FrontpageCards.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports